import { Swiper, Autoplay } from "swiper/bundle";
import hoverintent from 'hoverintent';
export default class MapSwiper {
    constructor() {
        console.log('%c👍🏼 Swiper Map', 'color: yellow');
        
        this.mapSwipers = document.querySelectorAll(
            '.swiper--map'
        ) 
    }
    init() {
        this.mapSwipers.forEach((elem, i) => {
            let swiper = new Swiper(elem, {
                loop: true,
                freeMode: true,
                spaceBetween: 15,
                grabCursor: true,
                slidesPerView: 2.5,
                loop: true,
                allowTouchMove: true,
                speed: 5000,
                freeModeMomentum: false,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: true
                },
                breakpoints: {
                    400: {
                        slidesPerView: 3,
                    },
                    600: {
                        slidesPerView: 4,
                    },
                    800: {
                        slidesPerView: 5,
                    },
                    1000: {
                        slidesPerView: 6,
                    },
                    1200: {
                        slidesPerView: 7,
                    },
                }
            });  
            
            let wrapper = elem.querySelector('.swiper-wrapper');
            let transformValue;

            hoverintent(wrapper,
                function() {
                    swiper.autoplay.stop();
                    transformValue = wrapper.style.transform;
                    wrapper.style.transitionDuration = "0ms";
                    wrapper.style.transform = "translate3d(" + swiper.getTranslate() + "px, 0px, 0px)";
                }, function() {
                    // wrapper.style.transitionDuration = swiper.params.speed + "ms";
                    // wrapper.style.transform = transformValue;
                    // swiper.autoplay.start();
                });
              
        })
    } 
}